import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { X, Upload, Download, FileSpreadsheet } from "lucide-react";

export default function ApplicationImportDialog({ onClose, onDone }) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const downloadTemplate = async () => {
    try {
      const res = await api.get("/applications/import/template", { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = "basvuru_sablon.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) { toast.error("Şablon indirilemedi"); }
  };

  const submit = async () => {
    if (!file) { toast.error("Lütfen bir Excel dosyası seçin"); return; }
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/applications/import", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success(`${data.inserted} başvuru içe aktarıldı${data.skipped ? `, ${data.skipped} atlandı` : ""}`);
      onDone();
    } catch (e) { toast.error(e.response?.data?.detail || "İçe aktarma başarısız"); }
    finally { setLoading(false); }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-start justify-center bg-black/40 p-4 overflow-y-auto">
      <div className="bg-white border border-[#E7DECC] rounded-sm w-full max-w-lg my-16" data-testid="app-import-dialog">
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#E7DECC]">
          <h3 className="font-heading text-xl font-bold tracking-tight">Başvuru — Excel ile Toplu Ekle</h3>
          <button onClick={onClose} data-testid="app-import-close" aria-label="Kapat" className="text-[#8C8377] hover:text-[#26231E]"><X className="w-5 h-5" /></button>
        </div>
        <div className="p-6">
          <div className="border border-[#E7DECC] bg-[#F3ECDD] rounded-sm p-4 mb-5">
            <div className="kicker mb-2">1. ŞABLONU İNDİRİN</div>
            <p className="text-sm text-[#8C8377] mb-3">Sütunlar: Ad Soyad, TC No, Telefon, Referans Telefon, E-posta, Adres, Açık İcra/Araç/Taşınmaz, Sektör, Kurum, Net Maaş, İş Yılı, Telefon Modeli.</p>
            <button onClick={downloadTemplate} data-testid="app-download-template" className="flex items-center gap-1.5 px-3 py-2 border border-[#E7DECC] bg-white rounded-sm text-sm font-medium hover:bg-[#EFE7D6] transition-colors duration-150">
              <Download className="w-4 h-4 text-[#B8933F]" /> Şablonu İndir (.xlsx)
            </button>
          </div>
          <div className="kicker mb-2">2. DOSYAYI YÜKLEYİN</div>
          <label htmlFor="app-import-file" className="flex flex-col items-center justify-center gap-2 border-2 border-dashed border-[#E7DECC] rounded-sm py-8 cursor-pointer hover:border-[#B8933F] transition-colors duration-150">
            <FileSpreadsheet className="w-8 h-8 text-[#2F6E4E]" />
            <span className="text-sm text-[#8C8377]">{file ? file.name : "Dosya seçmek için tıklayın (.xlsx)"}</span>
            <input id="app-import-file" type="file" accept=".xlsx" className="hidden" data-testid="app-import-file-input" onChange={(e) => setFile(e.target.files?.[0] || null)} />
          </label>
          <div className="flex justify-end gap-3 mt-6">
            <button onClick={onClose} className="px-4 py-2 border border-[#E7DECC] rounded-sm text-sm font-medium hover:bg-[#EFE7D6] transition-colors duration-150">İptal</button>
            <button onClick={submit} disabled={loading} data-testid="app-import-submit" className="flex items-center gap-1.5 px-6 py-2 bg-[#B8933F] hover:bg-[#9C7A33] text-white rounded-sm text-sm font-medium transition-colors duration-150 disabled:opacity-60">
              <Upload className="w-4 h-4" /> {loading ? "İçe aktarılıyor..." : "İçe Aktar"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
